import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-tibao-1-jgd",
  "use": "icon-tibao-1-jgd-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-tibao-1-jgd\"><defs><style type=\"text/css\"></style></defs><path d=\"M384 384h256v64h-256zM544 843.584h-64V928h-160v64h384v-64h-160z\" p-id=\"4219\" /><path d=\"M512 32C299.936 32 128 203.936 128 416s171.936 384 384 384 384-171.936 384-384S724.064 32 512 32z m0 704c-176.736 0-320-143.264-320-320S335.264 96 512 96s320 143.264 320 320-143.264 320-320 320z\" p-id=\"4220\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol